import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {ProjectListItem} from '../../../modules/apps/project/core/_models'
import {
  createResponseContext,
  initialQueryResponse,
  stringifyRequestQuery,
} from '../../../../_metronic/helpers'
import {useHomeQueryRequest} from './HomeRequestProvider'
import {GET_PROJECT_LIST_URL, getProjectList} from '../../../modules/apps/project/core/_requests'
import {useAuth} from '../../../modules/auth'
import {toast} from 'react-toastify'

const HomeResponseContext = createResponseContext<ProjectListItem>(initialQueryResponse)
const HomeResponseProvider: FC<{children: any}> = ({children}) => {
  const {state} = useHomeQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
  const {setAuthMessage, logout} = useAuth()

  console.log('Liste state : ', state)

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [query, updatedQuery])
  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    [GET_PROJECT_LIST_URL, state],
    async () => {
      return (
        await getProjectList(
          state,
          (message: string) => {
            setAuthMessage(message)
            logout()
          },
          ({Message, MessageType, Toast, ToastType}) => {
            if (Message && MessageType === 'Success') {
              //
            } else if (Message && MessageType === 'Error') {
              //
            } else if (Toast && ToastType === 'Success') {
              toast(Toast, {type: 'success'})
            } else if (Toast && ToastType === 'Error') {
              toast(Toast, {type: 'error'})
            }
          }
        )
      ).data
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  return (
    <HomeResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
      {children}
    </HomeResponseContext.Provider>
  )
}

const useHomeQueryResponse = () => useContext(HomeResponseContext)

const useHomeResponseData = () => {
  const {response} = useHomeQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

// const useQueryResponsePagination = () => {
//   const defaultPaginationState: PaginationState = {
//     Links: [],
//     ...initialQueryState,
//   }

//   const {response} = useQueryResponse()
//   if (!response || !response.Payload || !response.Payload.Pagination) {
//     return defaultPaginationState
//   }

//   return response.Payload.Pagination
// }

const useHomeLoading = (): boolean => {
  const {isLoading} = useHomeQueryResponse()
  return isLoading
}

export {
  HomeResponseProvider,
  useHomeQueryResponse,
  useHomeResponseData,
  // useQueryResponsePagination,
  useHomeLoading,
}
